import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
var a = "undefined" != typeof window && new ( /*#__PURE__*/function () {
  function _class() {
    var _this = this;

    _classCallCheck(this, _class);

    this.raf = function (a) {
      requestAnimationFrame(_this.raf);
      var t = a - _this.now;
      _this.now = a;

      for (var s = 0; s < _this.callbacks.length; s++) {
        _this.callbacks[s].callback(a, t);
      }
    }, this.callbacks = [], this.now = performance.now(), requestAnimationFrame(this.raf);
  }

  _createClass(_class, [{
    key: "add",
    value: function add(a) {
      var _this2 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.callbacks.push({
        callback: a,
        priority: t
      }), this.callbacks.sort(function (a, t) {
        return a.priority - t.priority;
      }), function () {
        return _this2.remove(a);
      };
    }
  }, {
    key: "remove",
    value: function remove(a) {
      this.callbacks = this.callbacks.filter(function (_ref) {
        var t = _ref.callback;
        return a !== t;
      });
    }
  }]);

  return _class;
}())();
export { a as default };